
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-dark text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">
              <span className="text-primary">Yıldırım</span> Reklam
            </h3>
            <p className="text-gray-300 mb-4">
              Ankara'da dijital baskı, tabela ve açıkhava reklam çözümlerinde 
              yıldırım hızında hizmet, kurumsal kalite.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-primary">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-primary">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-primary">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              <li><Link to="/hizmetler/dijital-baski" className="text-gray-300 hover:text-primary">Dijital Baskı</Link></li>
              <li><Link to="/hizmetler/tabela-sistemleri" className="text-gray-300 hover:text-primary">Tabela & Işıklı Sistemler</Link></li>
              <li><Link to="/hizmetler/arac-giydirme" className="text-gray-300 hover:text-primary">Araç Giydirme</Link></li>
              <li><Link to="/hizmetler/cephe-kaplama" className="text-gray-300 hover:text-primary">Cephe Kaplama</Link></li>
              <li><Link to="/hizmetler/cnc-lazer" className="text-gray-300 hover:text-primary">CNC & Lazer İşleri</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li><Link to="/hakkimizda" className="text-gray-300 hover:text-primary">Hakkımızda</Link></li>
              <li><Link to="/portfolyo" className="text-gray-300 hover:text-primary">Portföy</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-primary">Blog</Link></li>
              <li><Link to="/sss" className="text-gray-300 hover:text-primary">SSS</Link></li>
              <li><Link to="/kvkk" className="text-gray-300 hover:text-primary">KVKK</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">İletişim</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-primary mt-1 mr-3"></i>
                <span className="text-gray-300 text-sm">
                  Kazım Karabekir Caddesi No:91 D:28,<br />
                  Başkent İş Merkezi, 06070 Altındağ/Ankara
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-primary mr-3"></i>
                <a href="tel:+903123808099" className="text-gray-300 hover:text-primary">
                  0312 380 80 99
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-whatsapp-line text-primary mr-3"></i>
                <a href="https://wa.me/908503073704" className="text-gray-300 hover:text-primary">
                  +90 850 307 3704
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-primary mr-3"></i>
                <a href="mailto:yildirimdijital@gmail.com" className="text-gray-300 hover:text-primary">
                  yildirimdijital@gmail.com
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-primary mr-3"></i>
                <span className="text-gray-300 text-sm">Pzt-Cmt: 08:00-18:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Ankara Yıldırım Reklam. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <Link to="/gizlilik" className="text-gray-400 hover:text-primary text-sm">Gizlilik Politikası</Link>
            <Link to="/cerez" className="text-gray-400 hover:text-primary text-sm">Çerez Politikası</Link>
            <a href="https://cdco.com.tr" className="text-gray-400 hover:text-primary text-sm">Bu web tasarımı CDCO tarafından yapılmıştır</a>
          </div>
        </div>
      </div>
    </footer>
  );
}